import { httpClient } from '@alfa-bank/site-http-client';
import { AUTH_STATUS } from '@alfa-bank/site-envconfig';

/**
 * Проверка статуса авторизации.
 *
 * {@link - https://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=2119631459 - аналитика}
 */
export const checkAuthStatus = () => httpClient.get(AUTH_STATUS());
